<template>
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <el-form  :model="role" ref="role"  label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.RoleName") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item 
                      prop="roleName"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'blur'
                      }"
                    >
                    <el-input
                      v-model.trim="role.roleName"
                      :name="'roleName'"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.RoleType") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-3">
                  <div>
                    <el-select disabled clearable v-model="role.roleType" name="roleType">
                      <el-option 
                      v-for="item in roleTypeObj"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.FunctionSelection") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                   <v-jstree :data="functionList" show-checkbox multiple allow-batch whole-row @item-click="itemClick"></v-jstree>
                </div>
              </div>

              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" v-if="!$route.query.id&&checkPermission('ROLE_LIST_NEW')||$route.query.id&&checkPermission('ROLE_LIST_UPDATE')"  @click="checkEvent()">{{$t("message.Save") }}</div>
                    <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import VJstree from 'vue-jstree'

export default {
  mixins: [config.globalMixin],
  components: {
    VJstree 
  },
  data() {
    return {
      role: {},
      roleList:[],
      functionList:[],
      node:[],
      roleTypeObj:[]
    };
  },
  created() {
    this.init();
  },
  mounted() {
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj();
        obj.roleId = id;
        obj.apiUrl = '/getSystemRoleDetail'
        var data = await this.$store.dispatch("apiEvent", obj);
        if(!data) return;
        this.$set(this, "role", data.data.result);
        this.node = data.data.result.systemFuncs;
        this.getRoleList();
      } else {
        let initUser = {
          id: null,
          roleType: 1,
          roleName: "",
        };
        this.node = [];
        this.$set(this, "role", initUser);
        this.getRoleList();
      }
      this.roleTypeObj=[{
        value: 0,
        label: this.$i18n.t("message.Super Admin")
      }, {
        value: 1,
        label: this.$i18n.t("message.Platform")
      }]
    },
    async getRoleList(){
        let obj = this.getAuthObj();
        obj.apiUrl = '/getSystemFuncAllList'
        var data = await this.$store.dispatch("apiEvent", obj);
        if(!data) return;
        for (var i = 0; i < data.data.result.length; i++) {
            data.data.result[i].selected = false
            for(var j = 0; j < this.node.length; j++){
                if(data.data.result[i].id==this.node[j]){
                    data.data.result[i].selected = true;
                }
            }
        }
        this.functionList = [];
        for(var i=0;i<data.data.result.length;i++){
          if(data.data.result[i].parentId == 0){
            this.functionList.push({
              "id": data.data.result[i].id,
              "text": data.data.result[i].funcName,
              "selected":data.data.result[i].selected,
              "opened": true,
              children: []
            })
          }
        }
        for (var i = 0; i < this.functionList.length; i++) {
            for (var j = 0; j < data.data.result.length; j++) {
                if (this.functionList[i].id == data.data.result[j].parentId) {
                    var node = {
                        "id": data.data.result[j].id,
                        "text": data.data.result[j].funcName,
                        "selected":data.data.result[j].selected,
                        "opened": true,
                        children: []
                    };
                    for (var k = 0; k < data.data.result.length; k++) {
                        if (data.data.result[k].parentId == data.data.result[j].id) {
                            node.children.push({
                                "id": data.data.result[k].id,
                                "text": data.data.result[k].funcName,
                                "selected":data.data.result[k].selected,
                                children: []
                            });
                        }
                    }
                    this.functionList[i].children.push(node);
                }
            }
        }
        this.$set(this, "roleList", data.data.result);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){}
            }]
        });
      }
    },
    checkEvent:function(){

        this.$refs["role"].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            return false;
          }
        });
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for(var key in this.role){
          obj[key] = this.role[key];
        }
        var ids=[];
        for(var i=0;i<this.functionList.length;i++){
          if(this.functionList[i].selected){
            ids.push(this.functionList[i].id);
          }
          for(var j=0;j<this.functionList[i].children.length;j++){
            if(this.functionList[i].children[j].selected){
              ids.push(this.functionList[i].children[j].id);
            }
            for(var k=0;k<this.functionList[i].children[j].children.length;k++){
              if(this.functionList[i].children[j].children[k].selected){
                ids.push(this.functionList[i].children[j].children[k].id);
              }
            }
          }
        }
        obj.funcIds = ids.join(',')
        if(this.$route.query.id){
          obj.roleId = this.$route.query.id;
          obj.apiUrl = '/updateSystemRole'
          var data = await this.$store.dispatch("apiEvent", obj);
        }else{
          obj.apiUrl = '/createSystemRole'
          var data = await this.$store.dispatch("apiEvent", obj);
        }
        if(!data) return;
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
      }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj();
        obj.roleIds = [this.$route.query.id];
        let data = await this.$store.dispatch("deleteSystemRole", this.setFormData(obj));
        if(!data) return;
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
      }
    },
    itemClick (node) {
    }
  }
};
</script>
